import type { Combobox } from '@angular/aria/combobox';

/** Chiude il combobox dopo il commit del valore (popup resta nel DOM con Angular Aria). */
export function closeAriaCombobox(combobox: Combobox<unknown> | undefined): void {
  queueMicrotask(() => combobox?.close());
}
